import Loadable from '@townsquare/loadable';
import { aggGoalRoute } from '@townsquare/routes/agg-goal-view';
import { aggGoalViewResource } from './resources/AggGoalViewResource';
import { aggGoalViewTabResource } from './resources/AggGoalViewTabResource';
import { Skeleton } from '@townsquare/griffin-main-header/skeleton';

aggGoalRoute.component = Loadable({
	loader: () => import(/* webpackChunkName: "agg-goal-view" */ './components/AggGoalView'),
	loading: Skeleton,
});
aggGoalRoute.nav4Layout = 'custom';
aggGoalRoute.relayEnvironment = 'agg';
aggGoalRoute.resources = [aggGoalViewResource, aggGoalViewTabResource];

export const aggGoalViewRoute = aggGoalRoute;
